import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SentOrdersCardResponseNormalized } from '../../../../../../store/rateManagement/selector';

export declare namespace CardTypes {
  export interface Props {
    item?: SentOrdersCardResponseNormalized;
    loading?: boolean;
  }
}

export const Card: React.FC<CardTypes.Props> = ({ item, loading }) => {
  const deviceType = useBreakpointValue({ base: 'mobile', sm: 'tablet', md: 'desktop' });
  const intervalText = (
    <Text isLoading={loading} fontSize={Typography['fontsize.xs']} color="neutral.medium">
      {item?.periodIntervalNormalized}
    </Text>
  );

  return (
    <HStack
      borderRadius={Spacing['inline.nano']}
      width={deviceType !== 'mobile' ? '32%' : '100%'}
      space={Spacing['stack.nano']}
      padding={Spacing['inset.xs']}
      background={Color['neutral.white']}>
      <VStack space={Spacing['inline.xxxs']}>
        <VStack space={Spacing['stack.nano']}>
          <HStack>
            <Icon
              name="Calendar"
              testId="calendar-icon"
              color={Color['neutral.medium']}
              size="xxxs"
            />
            <Text
              pl={Spacing['inline.quarck']}
              fontWeight={Typography['fontweight.regular']}
              color="neutral.medium">
              Período:
            </Text>
            <Text
              isLoading={loading}
              pl={Spacing['inline.quarck']}
              fontWeight={Typography['fontweight.semibold']}>
              {item?.periodValueNormalized}
            </Text>
          </HStack>

          {deviceType === 'tablet' && intervalText}
        </VStack>
        <VStack space={Spacing['stack.quarck']}>
          <Text
            isLoading={loading}
            paddingBottom={Spacing['inline.quarck']}
            color="neutral.medium"
            fontSize={Typography['fontsize.lg']}
            fontWeight={Typography['fontweight.semibold']}>
            {item?.typeFeeNormalized}
          </Text>
          <Text
            isLoading={loading}
            fontSize={Typography['fontsize.xl']}
            fontWeight={Typography['fontweight.semibold']}>
            {item?.valueNormalized}
          </Text>
        </VStack>
      </VStack>
      <VStack
        justifyContent={{ base: 'space-between', sm: 'flex-end', md: 'space-between' }}
        flex={1}
        alignItems="flex-end"
        height="100%">
        {deviceType !== 'tablet' && intervalText}
        <Icon
          name="InvestmentChart"
          testId="investiment-chart-icon"
          color={Color['brand.tertiary.principal']}
          size="sm"
        />
      </VStack>
    </HStack>
  );
};
